import axios from '@/lib/axios';
import { TerminateRequestParams } from '../types';

const createTerminate = (data: TerminateRequestParams, custCode: string | undefined) => {
  return axios.post(`/facility/flat_rates/terminate_cancels/${custCode}/terminate_create`, data);
}

export default createTerminate;